import Content from './content-interface';

export default class SetPushOrderHistory implements Content {
  pushOrderNumber: string;

  pushOrderExpirationDate: string;

  constructor(obj: any = {}) {
    this.pushOrderNumber = obj.pushOrderNumber || '';
    this.pushOrderExpirationDate = obj.pushOrderExpirationDate || '';
  }

  public static of(obj: any = {}): SetPushOrderHistory {
    return new SetPushOrderHistory(obj);
  }
}
